

import { useToast, toast } from "@/hooks/use-toast";

// Define a type for our non-JSX action format
interface NonJSXAction {
  label: string;
  onClick: () => void;
}

// Export original toast functions
export { useToast, toast };

// Create enhanced version with environment awareness
export const safeToast = (props: any) => {
  try {
    // Convert non-JSX action to JSX if needed
    if (props.action && typeof props.action === 'object' && 'label' in props.action) {
      const { label, onClick } = props.action as NonJSXAction;
      // We're using a simple approach here to avoid JSX
      // This will be interpreted correctly by the toast component
      props = {
        ...props,
        action: {
          type: "ToastAction",
          props: {
            onClick,
            children: label
          }
        }
      };
    }
    return toast(props);
  } catch (e) {
    console.error('Toast error:', e);
    // Fallback to console log if toast fails
    console.log('Toast message:', props.title, props.description);
    return { id: 'fallback', dismiss: () => {} };
  }
};

